import type { IUserSiteService } from "./IUserSiteService";
import type { ApiUserSite, ApiReturnUserSite } from "@highimpact-frontend/api-types";
import { api_config } from "../../../api-commons";


class UserSiteService implements IUserSiteService {
    async add(params: ApiUserSite): Promise<ApiReturnUserSite> {
        const response = await api_config.post(`/users/${params.user_id}/sites/${params.site_id}`);
        return response.data;
    }
    async update(params: ApiUserSite): Promise<ApiReturnUserSite> {
        const response = await api_config.put(`/users/${params.user_id}/sites/${params.site_id}`);
        return response.data;
    }

    async delete(params: ApiUserSite): Promise<ApiReturnUserSite> {
        const response = await api_config.delete(`/users/${params.user_id}/sites/${params.site_id}`);
        return response.data;
    }
}

const instance = new UserSiteService();
export default instance;